var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var updateInfiniteDataItem = function (oldData, matchFunc, updateFunc) {
    var newPages = oldData === null || oldData === void 0 ? void 0 : oldData.pages.map(function (page) { return page.map(function (x) { return (matchFunc(x) ? updateFunc(x) : x); }); });
    return __assign(__assign({}, oldData), { pages: newPages });
};
export var removeInfiniteDataItem = function (oldData, matchFunc) {
    var newPages = oldData === null || oldData === void 0 ? void 0 : oldData.pages.map(function (page) { return page.filter(function (x) { return matchFunc(x) === false; }); });
    return __assign(__assign({}, oldData), { pages: newPages });
};
export var updateInfiniteDataItemById = function (oldData, updatedItem, updateFunc) {
    if (updateFunc === void 0) { updateFunc = function (a, b) { return (__assign(__assign({}, a), b)); }; }
    return updateInfiniteDataItem(oldData, function (x) { return x.id === updatedItem.id; }, function (a) { return updateFunc(a, updatedItem); });
};
export var findById = function (data, id) { return data === null || data === void 0 ? void 0 : data.pages.flat(1).find(function (x) { return x.id === id; }); };
export var findTaskById = function (data, id) {
    for (var p = 0; p < data.pages.length; p += 1) {
        var page = data.pages[p];
        for (var m = 0; m < page.length; m += 1) {
            var mainTask = page[m];
            if (mainTask.id === id)
                return {
                    task: mainTask,
                    mainTask: mainTask,
                    mainTaskIndex: m,
                    pageIndex: p,
                };
            // Try searching in children
            if (mainTask.children) {
                for (var s = 0; s < mainTask.children.length; s += 1) {
                    var subTask = mainTask.children[s];
                    if (subTask.id === id)
                        return {
                            task: subTask,
                            mainTask: mainTask,
                            mainTaskIndex: m,
                            subTask: subTask,
                            subTaskIndex: s,
                            pageIndex: p,
                        };
                }
            }
        }
    }
    return null;
};
export var updateTask = function (data, id, updateFunc) {
    var findResult = findTaskById(data, id);
    if (!findResult)
        return data;
    var pages = __spreadArray([], data.pages, true);
    var page = __spreadArray([], pages[findResult.pageIndex], true);
    pages[findResult.pageIndex] = page;
    var mainTask;
    if (findResult.subTask) {
        mainTask = __assign({}, page[findResult.mainTaskIndex]);
        mainTask.children = __spreadArray([], mainTask.children, true);
        mainTask.children[findResult.subTaskIndex] = updateFunc(__assign({}, mainTask.children[findResult.subTaskIndex]));
    }
    else {
        mainTask = updateFunc(__assign({}, page[findResult.mainTaskIndex]));
    }
    page[findResult.mainTaskIndex] = mainTask;
    return __assign(__assign({}, data), { pages: pages });
};
export var insertNewMainTask = function (data, task) {
    var pages = __spreadArray([], data.pages, true);
    if (pages.length === 0)
        pages = [];
    pages[0] = __spreadArray([__assign({}, task)], pages[0], true);
    return __assign(__assign({}, data), { pages: pages });
};
